import { skipToken } from "@reduxjs/toolkit/query/react";
import { useState, useEffect } from "react";

import { useVmsSearchQuery } from "@/api/elasticSearch/vmsSearchApi";
import { DEFAULT_MAP_CONFIG } from "@/common/components/MapLandingPage/Map/MapHelper";
import { useSelector, RootState } from "@/store";
import { ResultTypes, SearchResult } from "@/utilities/types/search";

import { Map } from "../Map";


export const SearchMap = () => {
    const mapSearchArg = useSelector((state: RootState) => state.elasticSearch.mapSearchArg);
    const { searchUnits, isFetching, isSuccess } = useVmsSearchQuery(mapSearchArg ?? skipToken, {
        selectFromResult: ({ data, ...rest }) => ({
            ...rest,
            searchUnits: data?.data.results.map((r: SearchResult<ResultTypes>) => r.source) ?? [],
        }),
    });
    const [firstSuccess, setFirstSuccess] = useState(false);


    useEffect(() => {
        if (isSuccess && !firstSuccess) setFirstSuccess(true);
    }, [isSuccess]);

    return (
        <>
            <Map units={searchUnits} isFetching={isFetching} firstSuccess={firstSuccess} initialMapConfig={DEFAULT_MAP_CONFIG} />
        </>
    );
};
